import React from "react";
import "./index.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";

import FormComponent from "./Component/FormComponent";
import DataLoader from "./Component/DataLoader";
import ThankYou from "./Component/ThankYou";
import ErrorPage from "./Component/ErrorPage";
function App() {
  return (
    <>
      <Router>
        <AppContent />
      </Router>
    </>
  );
}

function AppContent() {
  const navigate = useNavigate();

  return (
    <>
      <Routes>
        <Route path="/redirect_login" element={<DataLoader />} />
        <Route path="/dashboard" element={<FormComponent />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/error500" element={<ErrorPage />} />
        <Route path="/" element={<FormComponent />} />
      </Routes>
    </>
  );
}

export default App;
